<template v-model='seen'>
<header class="nolauncher position-relative">   
    <nav id="menu" class="navbar fixed-top nav-custom nav-custom-after bgDarkTexture" >
        <div class="d-flex flex-row align-items-center justify-content-sm-start justify-content-between px-0">            
            <div class="d-flex"><a class="navbar-brand mx-0" :href="`https://${$store.state.meta.lang}.idcgames.com/`" aria-label="idcgames.com"></a></div>
            <div class="d-sm-flex d-none pl-2">
                <router-link class="logo game" :to="`/${$store.state.meta.lang}/landing`">
                   <h5> {{ $t('forum_title') }} </h5> 
                </router-link>
                <h5 v-if="$route.name != 'landing'" class="px-2" style="color: springgreen"> // </h5>
                <router-link class='logo game' :to='`/` + $store.state.meta.lang + `/game/${$store.state.gameID}`' v-if="!!$store.state.gameID && $store.state.meta.gamesDict[$store.state.gameID]">
                    <h5>{{ $store.state.meta.gamesDict[$store.state.gameID].name }}</h5>
                </router-link>
            </div>
        </div>
        <div class="d-sm-flex flex-row d-none align-items-center">
            <div class="d-none">
                <form id="searchForm"><span class="fa fa-search form-control-feedback"></span><input class="search-control" id="searchBox" type="text" placeholder="Search for your game" style="width: 300px;text-align: right;padding: 4px;padding-right: 10px;"></form>
                <div id="searched_game" class="bgDarkTexture" style="position: fixed; width: 500px; height: 80px; top: 47px; right: 42px; display: none;">
                    <div class="item">No elements found</div>
                </div>
            </div>            
            <template v-if="$store.state.username">
                <notification-button></notification-button>
                <router-link
                    v-if='$store.getters.isAdmin'
                    class='button button--thin_text'
                    :to='`/${$store.state.meta.lang}/game/${getGameSeo()}/admin`'
                >
                    {{ $t('forum_admin_settings') }}
                </router-link>                
            </template>
            <div class="d-sm-flex justify-content-xl-end justify-content-lg-end justify-content-sm-end" id="navbarNav">
                <ul class="navbar m-0 p-0">
                    <li class="nav-item">                        
                        <search-box header-bar='true' v-if="!!$store.state.gameID && $store.state.meta.gamesDict[$store.state.gameID]"></search-box>
                    </li>
                    <li v-if="showMenu" class="nav-item logged" style="display: list-item;">                        
                        <router-link class="nav-link" :to='`/${$store.state.meta.lang}/settings/general`'>
                            <font-awesome-icon icon="user-astronaut"/>
                            <span class="fontSecondarySmall pl-2 cUserName menu-reduced text-uppercase">{{ $store.state.username.toUpperCase() }}</span>
                        </router-link>
                    </li>
                    <li v-if="showMenu" class="nav-item logged actLogOff" style="display: list-item;">
                        <loading-button
                            @click='logout'
                            :loading='loadingLogout'
                            class='nav-link'
                        >
                            <font-awesome-icon icon="sign-out-alt"/>
                        </loading-button>
                    </li>  
                    <li v-if=" $store.state.username.length <= 0" class="nav-item mr-2" style="display: list-item;">
                        <b-dropdown size="sm" variant="link" toggle-class="text-decoration-none" no-caret>
                            <template #button-content>
                                <font-awesome-icon  :icon="{ prefix: 'fas', iconName: 'sign-in-alt' }" />
                            </template>
                            <b-dropdown-item 
                                v-b-modal.loginModal 
                                class="text-uppercase fontSecondarySmall">{{ $t('forum_login_txt') }}</b-dropdown-item>
                            <div class="dropdown-divider"></div>
                            <b-dropdown-item 
                                class="text-uppercase fontSecondarySmall mt-2"
                                v-b-modal.registerModal>{{ $t('forum_register_txt') }}</b-dropdown-item>
                        </b-dropdown>
                    </li>                  
                </ul>
            </div>
            <div class="nav-item dropdown d-sm-block d-none">                
                <a  class="nav-link" 
                    href="javascript:void(0)" 
                    v-on:click="seen=!seen" 
                    id="navbarDropdown2" 
                    role="button" 
                    data-toggle="dropdown" 
                    aria-haspopup="true" 
                    aria-expanded="false">
                    <span :class="`flag setflag flag-${flag}`" v-bind:alt="flag"></span>
                </a>                
                <div v-if="seen" class="dropdown-menu dropdown-menu-right language-menu p-0 border-0 bg-transparent show" aria-labelledby="navbarDropdown2">                    
                    <span v-for="lang in this.$mMultiLangs" :key="lang" class="flag-bg">                        
                        <a v-if="$store.state.meta.lang != lang" 
                                    :href='"/"+lang+"/landing"' 
                                    class="h6 mb-0 d-flex flex-row px-3 py-2 border-right border-bottom border-green-lighter bgDarkTexture box-shadow"  
                                    :class="{'border-left' : (lang=='ar' || lang=='ru')}"
                                    :title='lang.toUpperCase()' 
                                    :data-in='lang' 
                                    :data-out='lang'                                    
                                    >
                            <span :class='"flag flag-"+ getFlag(lang) +" mr-1"' :alt="lang"></span>{{ lang.toUpperCase() }}
                        </a>
                    </span>                    
                </div>
            </div>            
        </div>
    </nav>   
</header>
</template>

<script>
import LoadingButton from './LoadingButton';
import NotificationButton from './NotificationButton';
import SelectButton from './SelectButton';
import SearchBox from './SearchBox.vue';

export default {
    name: "navbar",
    props: ['options', 'value', 'name', 'touch-disabled'],
    components: {
        LoadingButton,
        NotificationButton,
        SelectButton,
        SearchBox
    },
    data(){       
        
        return {
            selectedIndex: this.getIndexFromValue(),
            seen: false,
            loadingLogout: false,
        }
    },
    computed: {                
        showMenu: {
            get(){
                return !!this.$store.state.username;
            },
            set(val){
                return !!val;
            }
        },
        flag: function(){
            return  this.$store.state.meta.lang == 'cs' ? 'cz':
                    this.$store.state.meta.lang == 'el' ? 'gr':
                    this.$store.state.meta.lang == 'da' ? 'dk':
                    this.$store.state.meta.lang == 'uk' ? 'ua':
                    this.$store.state.meta.lang == 'bs' ? 'ba':
                    this.$store.state.meta.lang == 'sr' ? 'sk':
                    this.$store.state.meta.lang == 'vi' ? 'vn':
                    this.$store.state.meta.lang == 'ja' ? 'jp':
                    this.$store.state.meta.lang == 'ar' ? 'sa':
                    this.$store.state.meta.lang == 'sv' ? 'se':
                    this.$store.state.meta.lang == 'zh' ? 'cn':
                    this.$store.state.meta.lang == 'ko' ? 'kr': this.$store.state.meta.lang;
        }
    },    
    methods:{
        getGameSeo(){
            let seoObj = this.$store.state.meta.gamesDict[this.$store.state.gameID];
            return ( seoObj && seoObj.seoname ) || '';
        },
        getIndexFromValue(v){
            // var self = this;   
            var index = 0;
            var v = v || this.$store.state.meta.lang;         

            if(v !== null) {
                this.options.forEach( (option, i) => {
                    if(option.value === v) {
                        index = i;
                    }
                })
            }
            return index;
        },
        changeLangs(seen, lang){
            this.seen=!seen
            this.$store.commit("setLang", lang);
            this.$i18n.locale = lang;            
        },        
        getFlag( lang ){

            return  lang == 'cs' ? 'cz': lang == 'el' ? 'gr':
                    lang == 'vi' ? 'vn': lang == 'ja' ? 'jp':
                    lang == 'ar' ? 'sa': lang == 'ko' ? 'kr': 
                    lang == 'sv' ? 'se': lang == 'bs' ? 'ba': 
                    lang == 'da' ? 'dk': lang == 'uk' ? 'ua': 
                    lang == 'sr' ? 'sk': lang == 'zh' ? 'cn': 
                    lang;
        },
        toggleMenu () {
            this.showMenu = !this.showMenu
        },
        refactored (){
            return this.$route.fullPath.split("/").filter((val, index)=> index > 1).join("/")
        },
        logout() {
            this.toggleMenu()
            this.loadingLogout = true

            this.axios.post(
                '/api/v1/user/' +
                this.$store.state.username +
                '/logout'
            ).then(res => {
                this.loadingLogout = false
                this.$store.commit('setUsername', '')
                this.$store.commit('setAdmin', res.data.admin)

                this.$socket.emit('accountEvent')

                this.$router.push('/')
            }).catch(err => {
                this.loadingLogout = false
                this.ajaxErrorHandler(err)
            })
        },
    },
    watch: {
        value () {
            this.selectedIndex = this.getIndexFromValue();
        }
    }
    
}
</script>


<style lang='scss' scoped>
html[data-useragent*='idclauncher'] header{margin-bottom: 3rem!important;}

/*
======================================================================================================================
Menu especi­fico del juego Top
======================================================================================================================
*/
.navbar li {
    list-style: none;
}

.navbar-brand {
    background-image: url("https://cdn.idcgames.net/img/default/logo-idc-dark.png");
    height: 50px;
    width: 44px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
}

.nav-custom-after .navbar-brand {
    background-image: url("https://cdn.idcgames.net/img/default/logo-idc-light.png");
    height: 40px;
}

.nav-custom {
    background-color: transparent;
    border-bottom: 1px solid #ffffff;
    transition: all 1s ease;
    padding: .3rem 1rem;
    height: 60px;
}

.nav-custom a {
    color: black;
}

.nav-custom-after {
    padding: 0rem 1rem;
    border-bottom: 1px solid #00ff7f;
    height: 47px;
}

.nav-custom-after a {
    color: #fff !important;
    transition: all 1s ease;
}

.nav-custom .dropdown-item, .nav-custom .dropdown-menu a{
    color: #fff;
}

.nav-custom .logged  a {
    color: #314954;
}

.nav-custom-after .logged a {
    color: #00ff7f!important;
}

@media (min-width: 576px) and (max-width: 767.98px){
    #navbarNav .fontSecondarySmall {
        font-size: 1.05rem;
    }
    #navbarNav ul {
        flex-wrap: nowrap;
    }
    #navbarNav .nav-link {
        padding: 0.5rem 0.55rem;
    }
    #navbarNav .menu-reduced {
        display: none;
    }
    #navbarNav{ padding-top: 0.1rem;}
}

.dropdown-menu-right {
    right: 0;
    left: auto;
}

/*Menu lateral*/
.featured {
    background: rgba(0,255,126,.2);
}

.btn-cta-small {
    display: none;
    white-space: nowrap;
    padding: 16px 30px;
    font-size: 1.5em;
    line-height: 0.1em;
    border: 5px solid black;
    left: 10%;
    cursor: pointer;
}

@media (max-width: 767.98px) {
.btn-cta-small {
    padding: 17px 15px;}
 }

.nav-custom-after a.btn-cta-small {
    color: black!important;
}

.nav-custom-after a:hover.btn-cta-small {
    color: #00ff7f!important;
}

.flag {
    transform: scale(.5);
    margin: -20px;
}

@media (max-width: 575.98px) {
.flag {
    transform: scale(.4);
    margin: -20px;}
}

.language-menu.dropdown-menu.show {
    display: flex;
    flex-direction: row;
    width: 94vw;
    justify-content: flex-end;
    height: auto;
    flex-wrap: wrap;
    box-shadow: none;
}

.language-menu a {
    width: 97px;
}

/*Responsive basado en la altura de la pantalla y no en el ancho*/
@media (max-height: 740px) {
    .modal .display-4 {
        font-size: 3rem;
        font-weight: 700;
        line-height: 1.2;
    }

    .modal .h6 {
        font-size: 1rem;
    }

    .modal h4 {
        font-size: 1.5rem;
    }
    .loginModal .btn-cta.mt-xl-4, .registerModal .btn-cta.mt-xl-4 {
        margin-top: .25rem !important;
    }
    .modalMainContentContainer .mt-xl-5 {
        margin-top: .75rem !important;
    }

    .modalMainContentContainer .pt-xl-4  {
        padding-top: .5rem !important;
    }
}
/*
======================================================================================================================
Botones de logado/no logado
======================================================================================================================
*/
 .unlogged, .logged {
    display: none;
}

#searchForm .search-control {
    padding-left: 2.375rem;
}

#searchForm .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 2.375rem;
    height: 2.375rem;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: #aaa;
}
</style>
<style>
.fontSecondarySmall {
    /* font-family: 'Bebas Neue';
    font-size: 1.3rem;
    font-weight: 500!important; */
    font-family: 'Bebas Neue', 'sans-serif';
    font-size: 1.3rem;
    line-height: 1.2rem;
    font-weight: 500!important;
}
.modal-backdrop {
    position:fixed;
    top:0;
    right:0;
    bottom:0;
    left:0;
    z-index:1040;
    background-color: rgba(0 ,0, 0,0.7)!important;
}
.modal-backdrop.fade {
 opacity:0;
}
.modal-backdrop.show {
 opacity:.7;
}
.btn-sm, .btn-group-sm > .btn, .btn-group-sm > .btn{
    font-size: 1rem!important;
}
#navbarDropdown2{
    line-height: 1.2;
}
.flag-bg{
    background: #14191e;
}
.dropdown-menu.show{
    background: #13181d;
}
ul.dropdown-menu.show{
    top: 10px!important;
    left: -60px!important;
}
.dropdown-divider {
    height: 0;
    margin: 0.5rem 0;
    overflow: hidden;
    border-top: 1px solid #00ff7f!important;
}

</style>
